import { delay } from 'lodash-es';
import { QUALITY_LABEL_SHOW, QUALITY_LAST_N_WILDIX, QUALITY_VIDEO_RES_WILDIX } from './actionTypes';
import { QUALITY_CONTROL_TIMERS_WILDIX } from './constant';
export function setQualityLastNWildix(number) {
    return {
        type: QUALITY_LAST_N_WILDIX,
        qualityLastN: number
    };
}
export function setQualityVideoResWildix(number) {
    return {
        type: QUALITY_VIDEO_RES_WILDIX,
        qualityVideoResolution: number
    };
}
// Explicitly typing as `number`
let controlVisibilityTimerID;
export function toggleControlVisibility(value) {
    return (dispatch, getState) => {
        clearTimeout(controlVisibilityTimerID);
        if (value) {
            dispatch(hideControlLabel());
        }
        dispatch({
            type: QUALITY_LABEL_SHOW,
            showLabel: value
        });
    };
}
export function hideControlLabel() {
    return (dispatch, getState) => {
        controlVisibilityTimerID = delay(() => {
            dispatch(toggleControlVisibility(false));
            console.error('hide');
        }, QUALITY_CONTROL_TIMERS_WILDIX.HIDE);
    };
}
